export default __webpack_public_path__ + "static/media/logo28.fabc1e62.png";